export default __webpack_public_path__ + "fe9e864688889f2c21f2e4a13e9ae7ef.jpg";